import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { assets } from '../../config/assets'
import { useAuthStore } from '../../store/authStore'
import LibraryHeader from './LibraryHeader'
import Footer from '../Footer'

/**
 * Layout for the Moja Biblioteka (My Library) area.
 *
 * - Blue floral background matching the homepage.
 * - Custom header with logo, menu pill, and profile pill.
 * - Content constrained to max 75% width, centered.
 * - Full-width footer at the bottom.
 * - Requires authentication; redirects unauthenticated users to login.
 */
export default function LibraryLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, isLoading } = useAuthStore()

  // Check auth on every mount / route change within the library.
  // Use replace: true so the protected library URL is not left in history;
  // clicking the browser back button from login returns to the previous page.
  useEffect(() => {
    if (!isLoading && !user) {
      navigate(`/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`, {
        replace: true,
      })
    }
  }, [user, isLoading, location, navigate])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-brand-blue flex items-center justify-center">
        <p className="text-brand-gold">Ładowanie...</p>
      </div>
    )
  }

  if (!user) {
    return null
  }

  return (
    <div className="min-h-screen flex flex-col relative bg-brand-blue">
      <div
        className="absolute inset-0 bg-cover bg-fixed bg-center pointer-events-none"
        style={{ backgroundImage: `url(${assets.backgroundPattern})` }}
        aria-hidden="true"
      />
      <div className="relative z-10 flex flex-col min-h-screen">
        <LibraryHeader />
        <main className="flex-1 w-full px-4 py-8 md:py-12">
          <div className="mx-auto w-full max-w-[75%]">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
    </div>
  )
}
